<template>
  <div>
    <v-form ref="formPD">
      <v-row v-if="confirmBirth">
        <v-col cols="1" />
        <v-col cols="10">
          <label>Data de nascimento</label>
        </v-col>
      </v-row>
      <v-row v-if="confirmBirth">
        <v-col cols="1" />
        <v-col
          cols="3"
          justify-end
        >
          <v-select
            @change="onChange($event)"
            :items="days"
            label="DIA"
            v-model="birthDay"
            ref="refBirthDay"
            :readonly="locked"
            :rules="[validateBirthDay]"
            dense
          />
        </v-col>
        <v-col
          cols="4"
          justify-end
        >
          <v-select
            @change="onChange($event)"
            :items="months"
            item-text="name"
            item-value="value"
            label="MÊS"
            v-model="birthMonth"
            ref="refBirthMonth"
            :readonly="locked"
            :rules="[validateBirthMonth]"
            dense
          />
        </v-col>
        <v-col
          cols="4"
          justify-end
        >
          <v-select
            @change="onChange($event)"
            :items="years"
            label="ANO"
            v-model="birthYear"
            ref="refBirthYear"
            :readonly="locked"
            :rules="[validateBirthYear]"
            dense
          />
        </v-col>
      </v-row>
      <v-row v-if="confirmCPF">
        <v-col cols="1" />
        <v-col
          cols="11"
          justify-end
        >
          <v-text-field
            type="text"
            v-model="cpfNumber"
            ref="refCpf"
            label="CPF"
            maxlength="14"
            :rules="[internalValidateCPF, rules.required]"
            @keypress="filterInput"
            @paste.prevent="filterPaste"
          />
        </v-col>
      </v-row>
      <v-row v-if="confirmRG">
        <v-col cols="1" />
        <v-col
          cols="11"
          justify-end
        >
          <v-text-field
            type="text"
            v-model="rgNumber"
            ref="refRg"
            label="RG"
            :rules="[validateRG, rules.required]"
          />
        </v-col>
      </v-row>
      <v-row v-if="confirmMotherName">
        <v-col cols="1" />
        <v-col
          cols="11"
          justify-end
        >
          <v-text-field
            v-model="motherName"
            ref="refMother"
            label="Nome da mãe"
            :rules="[validateMotherName, rules.required]"
          />
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { cpfValidation } from '@/utils/validations';

export default {
  data: () => ({
    confirmPersonalData: false,
    confirmBirth: false,
    confirmCPF: false,
    confirmRG: false,
    confirmMotherName: false,
    cpfNumber: '',
    motherName: '',
    days: [],
    months: [
      { name: 'Jan', value: '01' },
      { name: 'Fev', value: '02' },
      { name: 'Mar', value: '03' },
      { name: 'Abr', value: '04' },
      { name: 'Mai', value: '05' },
      { name: 'Jun', value: '06' },
      { name: 'Jul', value: '07' },
      { name: 'Ago', value: '08' },
      { name: 'Set', value: '09' },
      { name: 'Out', value: '10' },
      { name: 'Nov', value: '11' },
      { name: 'Dez', value: '12' }
    ],
    years: [],
    birthDay: '',
    birthMonth: '',
    birthYear: '',
    locked: false,
    rules: {
      required: value => !!value || 'Requerido'
    },
    setFocus: true
  }),
  updated() {
    if (this.setFocus) {
      if (this.confirmMotherName) {
        this.$refs.refMother.focus();
      }
      if (this.confirmRG) {
        this.$refs.rgNumber.focus();
      }
      if (this.confirmCPF) {
        this.$refs.refCpf.focus();
      }
      if (this.confirmBirth) {
        this.$refs.refBirthDay.focus();
      }
      this.setFocus = false;
    }
  },
  mounted() {
    this.setFocus = true;
    for (let day = 1; day <= 31; day++) {
      const formattedDay = String(day).padStart(2, '0');
      this.days.push(formattedDay);
    }
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 16;
    const endYear = currentYear - 130;
    for (let year = startYear; year >= endYear; year--) {
      const formattedYear = String(year);
      this.years.push(formattedYear);
    }
  },
  methods: {
    load(entityJson) {
      // entityJson = { confirmPersonalData:boolean, confirmBirth:boolean, confirmCPF:boolean, confirmRG:boolean: confirmMotherName:boolean }
      this.confirmPersonalData = false;
      this.confirmBirth = false;
      this.confirmCPF = false;
      this.confirmRG = false;
      this.confirmMotherName = false;

      if (entityJson) {
        if (entityJson.confirmPersonalData) {
          this.confirmPersonalData = entityJson.confirmPersonalData;
          if (entityJson.confirmBirth) {
            this.confirmBirth = entityJson.confirmBirth;
          }
          if (entityJson.confirmCPF) {
            this.confirmCPF = entityJson.confirmCPF;
          }
          if (entityJson.confirmRG) {
            this.confirmRG = entityJson.confirmRG;
          }
          if (entityJson.confirmMotherName) {
            this.confirmMotherName = entityJson.confirmMotherName;
          }
        }
      }
    },
    filterInput(event) {
      const char = String.fromCharCode(event.which);
      const nextValue = this.cpfNumber + char;
      const formattedValue = this.formatCPF(nextValue);
      this.cpfNumber = formattedValue.returnValue;
      event.preventDefault();
      return false;
    },
    filterPaste(event) {
      const paste = (event.clipboardData || window.clipboardData).getData(
        'text'
      );
      const formattedValue = this.formatCPF(paste);
      this.cpfNumber = formattedValue.returnValue;
      if (formattedValue.returnStatus !== false) {
        event.preventDefault();
      }
    },
    formatCPF(value) {
      let returnStatus = true;
      let returnValue = '';
      const numbers = value.replace(/\D/g, '');
      let numbersReturn = value;
      const regex = /[^0-9.-]/g;
      numbersReturn = numbersReturn.replace(regex, '');
      returnValue = numbersReturn;
      if (numbers.length !== 11) {
        returnStatus = false;
        returnValue = this.getTruncatedString(returnValue, 14);
        return { returnStatus, returnValue };
      }

      returnValue = numbers.replace(
        /^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2}).*/,
        '$1.$2.$3-$4'
      );
      returnValue = this.getTruncatedString(returnValue, 14);
      return { returnStatus, returnValue };
    },
    internalValidateCPF(value) {
      const outValidate = cpfValidation(value);
      if (!outValidate) {
        return 'Número de CPF inválido.';
      } else {
        return outValidate;
      }
    },
    getTruncatedString(value, lenght) {
      if (!value) {
        return '';
      }
      return value.substring(0, lenght);
    },
    validateRG() {
      var msg = '';
      if (this.informeRG) {
        if (!this.rgNumber) {
          msg = 'O RG deve ser informado.';
        }
      }
      if (msg) {
        return msg;
      } else {
        return true;
      }
    },
    validateMotherName() {
      var msg = '';
      if (this.informeMotherName) {
        if (!this.motherName) {
          msg = 'O nome da mãe deve ser informado.';
        }
      }
      if (msg) {
        return msg;
      } else {
        return true;
      }
    },
    validatePersonalData() {
      let returnValidate = true;
      if (this.confirmPersonalData) {
        returnValidate = this.$refs.formPD.validate();
      }
      return returnValidate;
    },
    getValues() {
      let entityJson = null;
      if (this.confirmPersonalData) {
        entityJson = {};
        if (this.confirmCPF) {
          entityJson.cpfNumber = this.cpfNumber.replace(/\D/g, '');
        }
        if (this.confirmMotherName) {
          entityJson.motherName = this.motherName;
        }
        if (this.confirmRG) {
          entityJson.rgNumber = this.rgNumber.replace(/[^a-zA-Z0-9]/g, '');
        }
        if (this.confirmBirth) {
          const formatDate =
            this.birthYear + '-' + this.birthMonth + '-' + this.birthDay;
          entityJson.birth = formatDate;
        }
      }
      return entityJson;
    },
    onChange(value) {
      this.typeIdentifier = value;
      this.identifierDescripttion = 'Digite a ' + value;
      this.identifier = '';
    },
    validateBirthDay(value) {
      var msg = '';
      if (this.confirmBirth) {
        if (!this.birthDay) {
          msg = 'O dia de nascimento deve ser informado.';
        }
      }
      if (msg) {
        return msg;
      } else {
        return true;
      }
    },
    validateBirthMonth(value) {
      var msg = '';
      if (this.confirmBirth) {
        if (!this.birthMonth) {
          msg = 'O mês de nascimento deve ser informado.';
        }
      }
      if (msg) {
        return msg;
      } else {
        return true;
      }
    },
    validateBirthYear(value) {
      var msg = '';
      if (this.confirmBirth) {
        if (!this.birthYear) {
          msg = 'O ano de nascimento deve ser informado.';
        }
      }
      if (msg) {
        return msg;
      } else {
        return true;
      }
    }
  }
};
</script>
